import { firmClientKeys } from '../FirmClient/queryKeys';

export const spendingCategoryEstimateKeys = {
  base: ['spendingCategoryEstimate'],
  spendingCategoryEstimates: (householdID: string | undefined | null) => [
    'spendingCategoryEstimates',
    ...spendingCategoryEstimateKeys.base,
    ...firmClientKeys.household(householdID),
  ],
};
